import analytics from 'redux-analytics';
import updateVodSettings from 'shared/redux/server/actions/vod-settings/update';
import { createSender, createErrorSender } from './bi-with-state-defaults';


/*
 This is used in pair with redux-analytics. Each actions with meta: { analytics } will be processed by this module.
 Event handler name should be passed in analytics meta payload. Handlers can be registered externally.

 See also bi-middleware: module which helps to avoid any info about BI in clien code. bi-middleware has more priority
 over this module because it produces more clean code.
 */


export function defaultErrorHandler(send, { name, ...params }) {
  send(name, params);
}

export function defaultEventHandler(send, { name, ...params }) {
  send(name, params);
}


export function getBiLoggingMiddleware(eventHandlers, errorsHandlers = [defaultErrorHandler]) {
  let latestDispatch = null;
  let latestState = null;

  _.defaults(eventHandlers, { event: defaultEventHandler });

  function track({ type, payload }, state) {
    if (type === 'error') {
      return _.map(errorsHandlers, handler => handler(createErrorSender(state), payload, state));
    }

    const handler = eventHandlers[type];
    if (!handler) {
      return;
    }

    Promise.resolve(handler(createSender(state), payload, state))
      .then(function (settings) {
        const mergedSettings = _.isArray(settings) ?
          _.transform(settings, (res, setting) => _.merge(res, setting), {}) :
          settings;

        if (mergedSettings) {
          updateVodSettings(mergedSettings)(latestDispatch, () => latestState);
        }
      });
  }

  function actor(state, dispatch) {
    latestDispatch = dispatch;
    latestState = state;
  }

  return { middleware: analytics(track), actor };
}



// WEBPACK FOOTER //
// ./src/shared/bi/middleware.js